import { ECurrencies } from 'constants/enums';

export const DEFAULT_CONVERSION_CURRENCY = ECurrencies.USD;
